export default __webpack_public_path__ + "static/twitter-image-82614924ce25f0460da2f8631b5c1599.png";